import React from "react";
import {ConditionalRenderer} from "./ConditionalRenderer";

interface ModalProps {
    headerText?: string;
    onClickCloseOption: React.MouseEventHandler<HTMLDivElement>;
    boxClass?: string;
    headerTextContentRenderer?: Function;
    additionalOptionsRenderer?: Function;
    closeIconSrcOverride?: string;
    children: React.ReactNode;
}

export let Modal = function (props: ModalProps) {
    return (
        <div className="common-modal">
            <div className="common-modal-overlay">
                <div className={`common-modal-box ${props.boxClass || ''}`}>
                    <div className="common-modal-header">
                        <div className="common-modal-header-content">
                            <div className="common-modal-header-text-container">
                                {(() => {
                                    if (props.headerTextContentRenderer) {
                                        return props.headerTextContentRenderer()
                                    } else {
                                        return (
                                            <div className="common-modal-header-text">{props.headerText}</div>
                                        )
                                    }
                                })()}
                            </div>
                            <ConditionalRenderer
                                if={props.additionalOptionsRenderer !== undefined}
                                renderer={() => (
                                    <div className="common-modal-header-right-options-section">
                                        {(props.additionalOptionsRenderer as Function)()}
                                    </div>
                                )}
                            />
                            <div className="common-modal-close-option-container">
                                <div
                                    className="common-modal-close-option"
                                    onClick={props.onClickCloseOption}
                                >
                                    <img
                                        src={props.closeIconSrcOverride || "/static/images/close-green.svg"}
                                        className="common-modal-close-option-icon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="common-modal-body">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
};

